import React from 'react';
import replaceCommaWithDot from '../../../helpers/utils/replaceCommaWithDot';
import EstimationBlock from '../templates/common/estimationBlock';
import SliderControllerBlock from '../templates/common/sliderControllerBlock';

export default function template(context) {
    const calc = context.calc,
      model = calc.state.model;

  const estimationData = [
    {
      label: calc.l10n('CALCULATOR_MONTHLY_PAYMENT_NEW'),
      value: `${replaceCommaWithDot(model.getRequiredPayment().toLocaleString())} ${calc.l10n('UAH_ICON')}`,
    },
    {
      label: calc.l10n('CALCULATOR_CREDIT_SUM_NEW_DESIGN'),
      value: `${model.getCreditSum().toLocaleString()} ${calc.l10n('UAH_ICON')}`,
    },
    {
      label: calc.l10n('CALCULATOR_CREDIT_PAYMENTS'),
      value: `${model.getCreditTerm()}`,
    },
    {
      label: calc.l10n('CALCULATOR_NEW_PBP_ENTITY_COMISSION'),
      value: `${replaceCommaWithDot(model.getComission())} ${calc.l10n('UAH_ICON')}`,
    },
    {
      label: calc.l10n('CALCULATOR_NEW_PBP_ENTITY_INCOME'),
      value: `${replaceCommaWithDot(model.getIncome())} ${calc.l10n('UAH_ICON')}`,
    },
  ];

  return (
    <div className="calculator-new__content">
      <div className="calculator-new__top top-calculator-new">
        <div className="top-calculator-new__body">
          <h2 className="top-calculator-new__title">{calc.l10n('CALCULATOR_NEW_TITLE')}</h2>
        </div>
      </div>
      <div className="calculator-new__bottom">
        <SliderControllerBlock
          title={calc.l10n('CALCULATOR_NEW_SUM_CONTROLLERS_TITLE')}
          inputName="creditSum"
          value={model.getCreditSum()}
          currency={calc.l10n('UAH_ICON')}
          min={model.getMinSumEdge()}
          max={model.getMaxSumEdge()}
          step={model.getSumStep()}
          currencyOffset={calc.state.valueWith}
          hiddenValueRef={calc.hiddenValue}
          onInputChange={calc.handleChangeInput}
          onInputBlur={calc.blurChangeInput}
          onRangeChange={calc.handleChange4}
          showError={calc.state.error}
          errorText={`${calc.l10n("CALCULATOR_CREDIT_ERROR_TEXT")} ${model.getMinSumEdge()} ${calc.l10n('UAH_ICON')}`}
        />
        <SliderControllerBlock
          title={calc.l10n('CALCULATOR_NEW_PBP_ENTITY_CHOSEN_MONTHS_CONTROLLERS_TITLE')}
          inputName="shopCreditTerm"
          value={model.getCreditTerm()}
          min={model.getMinTermEdge()}
          max={model.getMaxTermEdge()}
          step="1"
          onRangeChange={calc.handleChange3}
          showError={false}
          readOnly={true}
        />
        <EstimationBlock
          title={calc.l10n('CALCULATOR_NEW_ESTIMATION_PAYMENTS_TITLE')}
          items={estimationData}
        />
      </div>
    </div>
  );
}
